import PropTypes from 'prop-types';
import styles from './FJCommunityList.module.less';

import FJCommunityMixViewList from '../../FJCommonComponent/FJCommunityMixViewList/FJCommunityMixViewList';
import FJActivePanel from '../../FJCommonComponent/FJActivePanel/FJActivePanel';
import FJFilterTypeContainer from '../../FJCommonComponent/FJFilterType/FJFilterTypeContainer';
const FJCommunityList = props => {
    const { active, communityList, getMoreData, communityPageInfo, curCategory } = props;
    const { initLoading, getMoreLoading, hasMore } = communityPageInfo;

    return (
        <FJActivePanel active={active} className={styles.container}>
            <FJFilterTypeContainer />
            <FJCommunityMixViewList
                active={active}
                className={styles.list}
                list={communityList}
                getMoreData={getMoreData}
                initLoading={initLoading}
                getMoreLoading={getMoreLoading}
                hasMore={hasMore}
                curCategory={curCategory}
                showEndTip={true}
            />
        </FJActivePanel>
    );
};

FJCommunityList.propTypes = {
    active: PropTypes.bool.isRequired,
    communityList: PropTypes.array.isRequired,
    getMoreData: PropTypes.func.isRequired,
    communityPageInfo: PropTypes.object.isRequired,
    curCategory: PropTypes.string.isRequired,
};

export default FJCommunityList;
